import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import "react-datepicker/dist/react-datepicker.css";
import MUIDataTable from "mui-datatables";
import { Button } from 'reactstrap';

import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';


import { 
    fetchRangePutting
 } from 'Actions';

 import AddItem from '../../../rangeintervention/putting/component/addform';

class PuttItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,

    };

    UNSAFE_componentWillMount() {
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            student: this.props.data.student,  
            startdate:this.props.data.startdate,
            enddate:this.props.data.enddate, 
            listdiv:true,
            adddiv:false,
            
        };

        this.onPrevSection = this.onPrevSection.bind(this); 
    }

    onPrevSection(){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        this.props.fetchRangePutting(student, stdate, eddate);
        this.setState({
            adddiv:false,
            listdiv:true, 
        }); 
    }

    onAddSession() {
		this.setState({ 
         listdiv:false,
         adddiv:true,
      });
    }



render() {
      
    const { rangeputtinglist, loading} = this.props; 
    const options = {
        filterType: 'dropdown',
        rowsPerPage: 50,
        rowsPerPageOptions: [50, 100, 150],
        selectableRowsHideCheckboxes: true,
    };

    const columns = [
        { name: "no", label: "NO" },
        { name: "date", label: "DATE" },
        { name: "coach", label: "COACH" },
        { name: "obsert", label: "OBSERVATION" },
        { name: "work", label: "WORK IN PROGRESS" },
      
    ];

    const tabledata1=rangeputtinglist.map((assmntval,idx) => {     
        
   
        return {
            no:idx+1,
            date: assmntval.cdate,
            coach: assmntval.grp_coachname,
            obsert:assmntval.grp_observation,
            work:assmntval.grp_workinprocess,
        }
    });

    


      return(
            <div>
                <div className="col-md-12 col-lg-12 col-sm-12">
                    <h1 className="text-center" style={{padding:"20px"}}> PUTTING</h1>
                </div>
                <div className="col-md-12 col-lg-12 col-sm-12" style={{marginBottom:"10px"}}>
                    <div className="ddd">
                        <div className="float-right"><Button onClick={this.props.onClick} className="btn btn-outline-warning"><i className="zmdi ti-angle-double-left"></i>  Back To Range</Button></div>
                        
                    </div>
                </div>

                {this.state.listdiv && 

                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard fullBlock>
                        <MUIDataTable
                                title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Putting</Button></div>}
                                data={tabledata1}
                                columns={columns}
                                options={options} 
                        />   
                        </RctCollapsibleCard>
                    </div>
                }   

                {this.state.adddiv && 
                   <AddItem onClick={this.onPrevSection} data={this.state}/> 
                } 
            </div>

              
    )
   
}
 
}

const mapStateToProps = ({ rangeputting}) => {
   
    const { rangeputtinglist, loading } = rangeputting;
	return {  rangeputtinglist, loading };   
}


export default connect(mapStateToProps, {
    fetchRangePutting
})(PuttItems);
